// Story 7.31 (ADO-1113), AC1/AC2/AC3 — the collected-offers listing's canonical URL.
//
// The collection is NOT a second screen (the ADO-1114 Offer Hub owns the landing shell): it is
// `/products` under one marker, so the Shopper reaches every offer on the active account's Range,
// at that account's live prices, with the same Add they use everywhere else, and orders without
// leaving it. `/products?offers=all` is the union of every live, scoped, priced and orderable offer,
// one row per product (no kind duplicates a listing). The kinds within it are narrowed through the
// listing's existing offer facets, whose counts come from the server and so only ever name a kind
// that has something live.
import { PRODUCTS_ROUTE } from '../../ordering/orderingChoices';

/** The query param and value that put `/products` into the collected-offers union mode. */
export const COLLECTED_OFFERS_PARAM = 'offers';
export const COLLECTED_OFFERS_ALL = 'all';

/** `/products?offers=all` — every live offer on the active account, in one place. */
export const COLLECTED_OFFERS_ROUTE = `${PRODUCTS_ROUTE}?${COLLECTED_OFFERS_PARAM}=${COLLECTED_OFFERS_ALL}`;

/** Whether the URL puts `/products` into the collected-offers union mode (`?offers=all`). */
export function collectedOffersFromSearch(search: URLSearchParams): boolean {
  return search.get(COLLECTED_OFFERS_PARAM) === COLLECTED_OFFERS_ALL;
}

/**
 * Append the collected-offers union marker to a query string when it is on — the inverse of
 * {@link collectedOffersFromSearch}. A no-op when off, so a URL never carries an empty `offers=`.
 */
export function appendCollectedOffersParam(
  params: URLSearchParams,
  collectedOffers: boolean,
): void {
  if (collectedOffers) params.set(COLLECTED_OFFERS_PARAM, COLLECTED_OFFERS_ALL);
}
